import { render, staticRenderFns } from "./ProfileEditContacts.vue?vue&type=template&id=f2f13982&scoped=true"
import script from "./ProfileEditContacts.vue?vue&type=script&lang=js"
export * from "./ProfileEditContacts.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditContacts.vue?vue&type=style&index=0&id=f2f13982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f13982",
  null
  
)

export default component.exports